<template>
  <div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5">
    <loading v-if="loadingState" />
    <div class="container mt-md-5 pt-4">
      <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      <div class="row justify-content-center text-left">
        <h3 class="Regular center h0 widthFull"><b>I tuoi preventivi</b></h3>
      </div>

      <div
        v-if="!presentPractices"
        class="row justify-content-center pb-5 pt-4 mt-md-5 vaillantCont"
      >
        <h4 class="black center widthFull mt-4">Non hai Preventivi</h4>
        <router-link
          class="btn btn-primary btn-lg btnYellow mt-2"
          to="/calcolatore"
          >Crea Preventivo</router-link
        >
      </div>

      <div
        v-if="presentPractices"
        class="row justify-content-center pb-3 pt-md-3 align-items-end"
      >
        <div class="col-md-4 pb-0">
          <h5 class="grey pt-0 pb-0">
            Totale Preventivi: <b class="black"> {{ countPractices }}</b>
          </h5>
          <h5 class="grey pt-0 mt-2">
            Totale Fatturato verso Clienti:
            <b class="black">€ {{ countCashClient | formatNumber }}</b>
          </h5>
          <h5 class="grey pt-0 mt-2">
            Totale da Cessione del Credito:
            <b class="black">€ {{ countCashInst | formatNumber }}</b>
          </h5>
        </div>
        <div class="col-10 col-md-4 center pl-5 pr-5">
          <VueSvgGauge
            v-if="totCash"
            :start-angle="-90"
            :end-angle="90"
            :value="totCash"
            :separator-step="step"
            :min="0"
            :innerRadius="70"
            :separatorThickness="1"
            :max="maxTotCash"
            :gauge-color="[
              { offset: 0, color: '#f39324' },
              { offset: 100, color: '#00897e' },
            ]"
            :scale-interval="100"
          >
            <div class="gaugeText">
              <p class="widhtFull pt-5 mt-2">€</p>
              <p class="widhtFull">
                <b>{{ totCash | formatNumber }}</b>
              </p>
              <p class="widhtFull"><small>Fatturabili</small></p>
            </div>
          </VueSvgGauge>
        </div>
        <div class="col-md-4">
          <form v-on:submit.prevent="filterValues">
            <h5 class="text-center grey mobSearchT">Ricerca Preventivo</h5>
            <div class="input-group mb-0">
              <input
                type="text"
                v-model="filter"
                class="form-control"
                placeholder="Numero Preventivo o Cognome ....."
              />
              <!--<div class="input-group-append">
              <button class="btn btn-outline-secondary" v-on:click.prevent="filterValues" type="button">CERCA</button>
            </div>
          -->
            </div>
          </form>
        </div>
      </div>

      <div class="row justify-content-center pb-5">
        <div v-if="!showFilterText" class="col-md-12 col-lg-12">
          <badger-accordion class="pb-5 mt-4" key="1231dsdfh32354134">
            <badger-accordion-item
              v-for="(item, key) in practicesFiltred"
              :key="item.code + '_' + countloop"
              class=""
              v-if="item.status != 9"
            >
              <template slot="header" class="center">
                <div class="row justify-content-center">
                  <div class="col-md-9">
                    <h5 class="black">
                      Preventivo N. <b class="underline">{{ item.code }}</b> del
                      {{ moment(item.created_at).format("DD-MM-YYYY HH:mm") }} (
                      {{ item.bonus }} ) per
                      <b> {{ item.client_name }} {{ item.client_lastname }} </b>
                    </h5>
                    <!--
                  <a class="btn btn-primary m-2 btn-sm" :href="item.invoice_quotation_pdf" target="_blank">
                    <font-awesome-icon icon="eye" size="sm" /> visualizza
                  </a>
                -->

                    <a
                      class="btn btn-primary m-2 btn-sm"
                      :href="item.invoice_quotation_pdf"
                      target="_blank"
                    >
                      <font-awesome-icon icon="print" size="sm" />
                      visualizza/stampa/scarica
                    </a>

                    <router-link
                      :to="{ name: 'acceptInvoice', params: { item: item } }"
                      class="btn btn-primary btn-green m-2 btn-sm"
                    >
                      <font-awesome-icon icon="clipboard-check" size="1x" />
                      Conferma preventivo
                    </router-link>

                    <router-link
                      :to="{ name: 'editInvoice', params: { item: item } }"
                      class="btn btn-primary m-2 btn-sm"
                    >
                      <font-awesome-icon icon="edit" size="1x" />
                      Modifica
                    </router-link>

                    <a
                      class="btn btn-danger m-2 btn-sm mr-md-5"
                      v-on:click.prevent="removeOrder(item.id, item.code, key)"
                    >
                       ARCHIVIA
                    </a>
                  </div>
                  <div class="col-md-3">
                    <span class="inline-block center relative mt-3">
                      <img class="qrcodeImg" :src="item.qrcode" />
                      <br /><small class="qrcodeText"
                        ><b>Conferma con</b></small
                      >
                    </span>

                    <a class="greenLinkAccordion Regular">Dettagli</a>
                  </div>
                </div>
              </template>
              <template slot="content" class="bbaLightColor">
                <div class="row justify-content-center pb-2 pl-md-3 pr-md-3">
                  <div class="col-md-12 col-lg-12">
                    <h5 class="black"><b>Indirizzo dell'immobile</b></h5>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    {{ item.building_address }} {{ item.building_civic }}
                    {{ item.building_city }} ({{ item.building_province }}) CAP:
                    {{ item.building_zip }}
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <h5 class="black pb-0"><b>Dati dell'intervento</b></h5>
                  </div>
                  <div class="col-md-6">
                    Tipo:
                    <span class="uppercase">{{ item.intervention_type }}</span>
                  </div>
                  <!--
                <div class="col-md-6">
                  Data: <span class="uppercase">{{moment(item.intervention_date).format('DD-MM-YYYY')}}</span>
                </div>
              -->
                </div>
              </template>
            </badger-accordion-item>
          </badger-accordion>

          <badger-accordion class="pb-5 mt-4" key="1231243412512354134">
            <badger-accordion-item
              class=""
              :id="'id_closed'"
              v-if="hasRemovedPractics"
            >
              <template slot="header" class="center">
                <h5 v-if="hasRemovedPractics" class="text-left black">
                  Preventivi Archiviati
                </h5>
                <p v-if="hasRemovedPractics" class="text-left black">
                  Attenzione! i dati della dashboard non includono il valori di
                  preventivi archiviati.
                </p>
              </template>
              <template slot="content" class="bbaLightColor">
                <badger-accordion class="pb-5 mt-4 greyBg">
                  <badger-accordion-item
                    v-for="(item, key) in practicesFiltred"
                    class=""
                    :id="'id' + item.code"
                    :key="item.code + '_r_' + countloop"
                    v-if="item.status == 9 && filter == ''"
                  >
                    <template slot="header" class="center">
                      <div class="row justify-content-center">
                        <div class="col-md-9">
                          <h5 class="black">
                            Preventivo N.
                            <b class="underline">{{ item.code }}</b> del
                            {{
                              moment(item.created_at).format("DD-MM-YYYY HH:mm")
                            }}
                            ( {{ item.bonus }} ) per
                            <b>
                              {{ item.client_name }} {{ item.client_lastname }}
                            </b>
                          </h5>
                          <!--
                  <a class="btn btn-primary m-2 btn-sm" :href="item.invoice_quotation_pdf" target="_blank">
                    <font-awesome-icon icon="eye" size="sm" /> visualizza
                  </a>
                -->

                          <a
                            class="btn btn-primary m-2 btn-sm"
                            :href="item.invoice_quotation_pdf"
                            target="_blank"
                          >
                            <font-awesome-icon icon="print" size="sm" />
                            visualizza/stampa/scarica
                          </a>

                          <a
                            class="btn btn-danger m-2 btn-sm mr-md-5"
                            v-on:click.prevent="
                              removeOrder(item.id, item.code, 'restore')
                            "
                          >
                            <font-awesome-icon
                              icon="trash-restore-alt"
                              size="sm"
                            />
                            Ripristina
                          </a>
                        </div>
                        <div class="col-md-3">
                          <!--
                  <span class="inline-block center relative mt-3">
                    <img class="qrcodeImg" :src="item.qrcode">
                    <br /><small class="qrcodeText"><b>Conferma con</b></small>
                  </span>

                  <a class="greenLinkAccordion Regular">Dettagli</a>
                -->
                        </div>
                      </div>
                    </template>
                    <template slot="content" class="bbaLightColor">
                      <div
                        class="row justify-content-center pb-2 pl-md-3 pr-md-3"
                      >
                        <div class="col-md-12 col-lg-12">
                          <h5 class="black"><b>Indirizzo dell'immobile</b></h5>
                        </div>
                        <div class="col-md-12 col-lg-12">
                          {{ item.building_address }} {{ item.building_civic }}
                          {{ item.building_city }} ({{
                            item.building_province
                          }}) CAP: {{ item.building_zip }}
                        </div>
                        <div class="col-md-12 col-lg-12">
                          <h5 class="black pb-0">
                            <b>Dati dell'intervento</b>
                          </h5>
                        </div>
                        <div class="col-md-6">
                          Tipo:
                          <span class="uppercase">{{
                            item.intervention_type
                          }}</span>
                        </div>
                        <div class="col-md-6">
                          Data:
                          <span class="uppercase">{{
                            moment(item.intervention_date).format("DD-MM-YYYY")
                          }}</span>
                        </div>
                      </div>
                    </template>
                  </badger-accordion-item>
                </badger-accordion>
              </template>
            </badger-accordion-item>
          </badger-accordion>
        </div>

        <div v-else class="col-md-12 col-lg-12 vaillantCont mt-4 pt-5 pb-5">
          <h5 class="center">Nessun risultato per {{ filter }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AUTH_REQUEST, AUTH_SOCIAL } from "actions/auth";
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import { BadgerAccordion, BadgerAccordionItem } from "vue-badger-accordion";
const moment = require("moment");

import { VueSvgGauge } from "vue-svg-gauge";

export default {
  name: "login",
  components: {
    BadgerAccordion,
    BadgerAccordionItem,
    VueSvgGauge,
  },
  data() {
    return {
      token: "",
      loadingState: false,
      loading: false,
      practices: {},
      countPractices: 0,
      countCashClient: 0,
      countloop: 1,
      countCashInst: 0,
      practicesFiltred: {},
      filter: "",
      presentPractices: true,
      moment: require("moment"),
      maxTotCash: 1000000,
      totCash: 0,
      step: 1000,
      showFilterText: false,
      hasRemovedPractics: false,
    };
  },
  methods: {
    async getPractices() {
      var _vue = this;
      this.loadingState = true;
      this.$log(_vue.getProfile.userToken);
      var token = _vue.getProfile.userToken;
      if(_vue.getProfile.corporateClient == 'agnellimetalli') {
        _vue.$router.push('/')
      }
      if (token) {
        var data = {
          type: 0,
          user_token: token,
        };
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        await axios({
          url: process.env.ROOT_API + "api/getPractices",
          method: "POST",
          data: { data },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
            _vue.practices = resp.data.practices;
            _vue.totCash = 0;
            _vue.countPractices = 0;
            _vue.countCashInst = 0;
            _vue.countCashClient = 0;
            for (var x in _vue.practices) {
              if (_vue.practices[x].status == "0") {
                // CALC ONLY VALID ORDERS
                _vue.countPractices++;
                _vue.totCash = (
                  parseFloat(_vue.totCash) +
                  parseFloat(_vue.practices[x].total_work_and_iva)
                ).toFixed(2);

                _vue.countCashInst = (
                  parseFloat(_vue.countCashInst) +
                  parseFloat(_vue.practices[x].total_bonus_savings)
                ).toFixed(2);
                _vue.countCashClient = (
                  parseFloat(_vue.countCashClient) +
                  parseFloat(_vue.practices[x].total_transfer_for_client)
                ).toFixed(2);
              }

              if (_vue.practices[x].status == "9") {
                _vue.hasRemovedPractics = true;
              }
            }
            this.totCash = parseFloat(this.totCash);
            if (this.totCash < 10000) {
              this.maxTotCash = 10000;
              this.step = 1000;
            } else if (this.totCash < 100000) {
              this.maxTotCash = 100000;
              this.step = 10000;
            } else if (this.totCash < 1000000) {
              this.maxTotCash = 1000000;
              this.step = 100000;
            } else if (this.totCash < 100000000) {
              this.maxTotCash = 100000000;
              this.step = 1000000;
            }
            _vue.practicesFiltred = _vue.practices;

            _vue.loadingState = false;
          })
          .catch((resp) => {
            this.presentPractices = false;
            _vue.loadingState = false;
            //_vue.$swal({
            //  type: 'error',
            //  title: 'Oops...',
            //  text: 'Riprova piu tardi!',
            //});
          });
      }
    },
    filterValues() {
      var text = this.filter.toLowerCase();
      this.$log(text);
      this.showFilterText = false;
      this.practicesFiltred = {};
      var z = 0;
      var bank = {};
      Object.assign(this.practicesFiltred, {});

      for (var x in this.practices) {
        if (
          (this.practices[x].code.toLowerCase().includes(text) ||
            this.practices[x].client_lastname.toLowerCase().includes(text) ||
            this.practices[x].client_name.toLowerCase().includes(text) ||
            this.practices[x].building_city.toLowerCase().includes(text)) &&
          this.practices[x].status != "9"
        ) {
          bank[x] = this.practices[x];
          z = z + 1;
        }
      }

      this.countloop = this.countloop + 1;

      Object.assign(this.practicesFiltred, bank);

      if (z == 0) {
        this.showFilterText = true;
      } else {
        this.showFilterText = false;
      }
    },
    removeOrder(id, code, key) {
      var id_order = id;
      var _vue = this;

      if (key == "restore") {
        var type = 0;
        var popUpText =
          "<br/>Sei sicuro di voler ripristinare Preventivo N. " +
          code +
          "?<br/><br/>";
      } else {
        var type = 9;
        var popUpText =
          "<br/>Sei sicuro di voler archiviare Preventivo N. " +
          code +
          "?<br/><br/>";
      }

      this.$swal({
        title: "Attenzione!",
        type: "warning",
        html: popUpText,
        showCancelButton: true,
        confirmButtonText: `SI`,
        cancelButtonText: `NO`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        this.$log(result);
        if (result.value) {
          var data = {
              id: id,
              user_token: _vue.getProfile.userToken,
              status: type
            }
          data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
          axios({
            url: process.env.ROOT_API + "api/changeOrderState",
            method: "POST",
            data:{data},
            headers: {
              Authorization: "Bearer " + process.env.AUTH_TOKEN,
              "Content-type": "application/json",
            },
          })
            .then((resp) => {
              _vue.getPractices();

              if (key == "restore") {
                _vue.$swal(
                  "Preventivo N. " + code + " <br/>è stato ripristinato ",
                  "",
                  "success"
                );
              } else {
                _vue.$swal(
                  "Preventivo N. " + code + " <br/>è stato archiviato ",
                  "",
                  "success"
                );
              }
            })
            .catch((resp) => {
              _vue.$swal("Ops. Riprova piu tardi", "", "error");
            });
        }
      });
    },
    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    },
  },
  watch: {
    getProfile: function (val) {
      if (val) {
        this.$log(val);
        this.getPractices();
      }
    },
    filter: function (val) {
      this.filterValues();
    },
  },
  created() {},
  mounted() {
    if (this.getProfile) {

      this.getPractices();
      
    }

    this.$scrollTo("#app", 700, {
      offset: -75,
    });
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "loginerror",
      "isAuthenticated",
      "isProfileLoaded",
      "authStatus",
    ]),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/offerte/index.vue